import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { observer } from 'mobx-react-lite';
import FilterItem from 'molecules/FilterItem/FilterItem';
import React from 'react';
import { IAggBucket, IFilter } from 'utils/globalTypes';

import s from './FiltersSidebarItem.module.scss';

interface FiltersSidebarItem {
  filterType?: string;
  filterValues?: IAggBucket[];
  showCounts?: boolean;
  keyName?: string;
  filters?: IFilter[];
  setFilters: (filters?: IFilter[] | undefined) => void;
}

const FiltersSidebarItem = ({
  filterType,
  filterValues,
  showCounts = true,
  keyName,
  filters,
  setFilters
}: FiltersSidebarItem) => {
  if (isEmpty(filterValues)) {
    return null;
  }

  const getSelectedCount = (filterValues: IAggBucket[] = []) =>
    filterValues.filter(({ isSelected }) => isSelected).length;

  const selectedCount = getSelectedCount(filterValues);
  const getCounter = () => {
    return !!selectedCount && <span>({selectedCount})</span>;
  };

  return (
    <div className={s.FiltersSidebarItem}>
      <div
        className={cn(s.FiltersSidebarItem__title, {
          [s['FiltersSidebarItem__title--active']]: selectedCount
        })}
      >
        {filterType} {getCounter()}
      </div>
      <div className={s.FiltersSidebarItem__content}>
        {filterValues &&
          filterValues.length !== 0 &&
          filterValues.map(
            (props, index) =>
              keyName && (
                <FilterItem
                  {...props}
                  className={s.FiltersSidebarItem__filter}
                  key={`${keyName}-${index}`}
                  filterKey={props.key}
                  filterField={keyName}
                  setFilters={setFilters}
                  count={showCounts ? props?.count : undefined}
                  isSelected={
                    !!filters?.filter(({ value }) => value && value.includes(props.key))?.length
                  }
                />
              )
          )}
      </div>
    </div>
  );
};

export default observer(FiltersSidebarItem);
